import { FC } from 'react'

import { MonthPicker } from '../../../monthpicker/ui/MonthPicker'
import { DateRange } from '../Calendar.types'
import { CalendarRangeBadge } from '../CalendarRangeBadge'
import { CalendarCaption } from '../caption/CalendarCaption'

type Props = {
  range?: DateRange
  month: Date
  setMonth: (date: Date) => void
  fromMonth?: Date
  showSelectedDate: boolean
  resolvedDisabled: {
    before?: Date
    after?: Date
  }
  onMonthClick: () => void
  onSelectMonth: (range?: DateRange) => void
  onRangeReset: () => void
  showOnlyRangeEnd?: boolean
  /** Диапазон для подсветки месяцев, если клик по месяцу задаёт конец промежутка */
  displayRange?: DateRange
}

export const MonthCalendarPanel: FC<Props> = ({
  range,
  month,
  setMonth,
  fromMonth,
  showSelectedDate,
  resolvedDisabled,
  onMonthClick,
  onSelectMonth,
  onRangeReset,
  showOnlyRangeEnd,
  displayRange
}) => (
  <div className="flex w-[304px] flex-col justify-between p-12 xxs:p-0">
    <CalendarCaption
      onMonthClick={onMonthClick}
      month={month}
      setMonth={setMonth}
      pickerMode="months"
      fromMonth={fromMonth}
      disabled={resolvedDisabled}
    />
    <div>
      <MonthPicker
        cellClassName="xxs:w-[101px]"
        monthYear={month}
        range={undefined}
        displayRange={displayRange}
        setRange={onSelectMonth}
        selectFullMonthRange={false}
        selectedMonth={month}
        disabled={resolvedDisabled}
      />
      {showSelectedDate && range?.from ? (
        <div className="py-8">
          <CalendarRangeBadge
            range={range}
            onRangeReset={onRangeReset}
            showOnlyRangeEnd={showOnlyRangeEnd}
          />
        </div>
      ) : (
        <div className="h-[48px]" />
      )}
    </div>
  </div>
)
